import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {RootState} from './store';
import {MedicalRecord} from "../types/medicalRecord";
import {medicalRecordsApi} from "../api/medicalRecords/medicalRecordsApi";
import {mapMedicalRecordDtoToMedicalRecord} from "../utils/medicalRecord";

const sliceName = 'medicalRecordSlice';
type MedicalRecordStatusType = 'idle' | 'loading' | 'failed';

const initialState = {
    medicalRecord: null as MedicalRecord,
    status: 'idle' as MedicalRecordStatusType,
};

export const fetchMedicalRecord = createAsyncThunk<
    MedicalRecord,
    {appointmentId: number},
    unknown
>(`${sliceName}/fetchMedicalRecord`, async ({appointmentId}) => {
    try {
        const {data} = await medicalRecordsApi.getMedicalRecord(
            appointmentId,
        );
        return mapMedicalRecordDtoToMedicalRecord(data);
    } catch (err) {
        console.error(err);
    }
});

const medicalRecordSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchMedicalRecord.pending, state => {
                state.status = 'loading';
            })
            .addCase(fetchMedicalRecord.fulfilled, (state, action) => {
                state.status = 'idle';
                state.medicalRecord = action.payload;
            })
            .addCase(fetchMedicalRecord.rejected, state => {
                state.status = 'failed';
            });
    },
});

export const selectMedicalRecord = (state: RootState) =>
    state.medicalRecord.medicalRecord;

export const selectMedicalRecordStatus = (state: RootState) =>
    state.medicalRecord.status;

export default medicalRecordSlice.reducer;
